import { render, staticRenderFns } from "./FacialRecMode.vue?vue&type=template&id=f40d626c&"
import script from "./FacialRecMode.vue?vue&type=script&lang=js&"
export * from "./FacialRecMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports